export class ContextualMenuChange<T, U> {
	public constructor(
		public action: U,
		public context: T
	) {}
}
